var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-catalog d-flex flex-column",
      class: _setup.isMobile ? "ga-6" : "ga-8",
    },
    [
      _vm.hasMedflexUi && (_vm.serviceClasses.length > 0 || _vm.isNotFound)
        ? _c(_setup.MedflexList, {
            attrs: {
              "service-classes": _vm.serviceClasses,
              "lpu-id": _vm.lpuId,
              "town-translit": _vm.townTranslit,
              "town-timedelta": _vm.townTimedelta,
              "is-enabled-direct": _vm.isEnabledDirect,
              "is-not-found": _vm.isNotFound,
              "show-all-button": _vm.showAllButton,
              "empty-src": _vm.emptySrc,
              "hide-group-titles": _vm.hideGroupTitles,
            },
            on: {
              "show-all": function ($event) {
                return _vm.$emit("show-all")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMedflexApi && _vm.showPagination
        ? _c(
            "div",
            { staticClass: "price-catalog__pagination" },
            [
              _c(_setup.PagePagination, {
                attrs: {
                  color: "var(--lpu-branding-color-primary)",
                  "current-page": _vm.currentPage,
                  "pages-length": _vm.pageCount,
                  mobile: _setup.isMobile,
                  "scroll-to-selector": "#prices",
                  "data-qa": "lpu_services_pagination",
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("page-input", $event.pageNumber)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.specialities.length || _vm.categories.length
        ? _c(_setup.ManualList, {
            attrs: {
              lpu: _vm.lpu,
              specialities: _vm.specialities,
              categories: _vm.categories,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }